<template>
  <!-- "Guardar como predeterminado": same look as the ones in Totals -->
  <button
    class="save-default-button"
    :disabled="disabled"
    @click.prevent="$emit('click')"
  >
    <i class="mdi mdi-content-save-outline"></i>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "SaveDefaultButton",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.save-default-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 6px;
  padding: 4px 8px;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  background: #fffbeb;
  font-size: 16px;
  font-weight: 600;
  color: #92400e;
  white-space: normal;

  &:hover:not(:disabled) {
    background: #fef3c7;
  }

  &:disabled {
    opacity: 0.6;
  }
}
</style>
